import styled from "styled-components";
import { AdvertCard } from "container/summer-camp/summer-camp.style";

export const AdsPreview = styled.div`
   max-width: 300px;
   width: 300px;
   margin: 0 auto;
   @media screen and (max-width: 990px) {
      width: 100%;
      margin: 0;
      max-width: 100%;
   }
`;

export const AdvertCardExtension = styled(AdvertCard)`
   p.description {
      margin-top: 10px;
      color: #333;
      font-weight: 400;
      font-size: 14px;
   }
`;

export const FinanceContainer = styled.div`
   margin-top: 200px;
   width: 100%;
   height: 70vh;
   display: flex;
   justify-content: center;
   align-items: center;
`;

export const FinanceFormContainer = styled.div`
   margin-bottom: 200px;
   margin-top: 100px;
   width: 40%;
   padding: 50px 100px 50px 100px;
   border: 1px solid #666666;
   border-radius: 8px;
   @media screen and (max-width: 990px) {
      width: 100%;
      padding: 20px;
      border: none;
   }
`;
